"use client";

import { BarChart, BarChartData, BarChartInfo } from "ui/analysis/bar-chart";

type Props = {
  chartData: BarChartData[];
  chartInfo: BarChartInfo;
  unit: string;
};

export const ClientBarChart = ({ chartData, chartInfo, unit }: Props) => (
  <BarChart
    data={chartData}
    info={chartInfo}
    yAxisWidth={50}
    yTicksFormatter={(value) => `${value ?? ""} ${unit}`}
    yTicksPaddingRight={16}
  />
);
